export interface INotificationMessage {    
    ID: number,
    EventID: number,
    UserID: string,
    EntityTypeID: number,
    ReferenceID: number,
    NoteObjectID: number,
    EntityTypeName: string,
    EntityTypeDescription: string,
    EntitySpecificID: number,
    Message: string,
    IsRead: boolean,
    GridOptions: string,
    total: number,
    AllRecord: boolean,
    CreatedOn: Date,
    ModifiedOn: Date,
}

export default class NotificationsService  {
    static getNotificationsCount = async (accessToken: string): Promise<number> => {        
        const headers = { 'Authorization': `Bearer ${accessToken}`};
        const resp = await fetch(process.env.REACT_APP_API_URL + `/api/v3.0/notifications/count`, {
            headers,
            mode: 'cors'
        });
        return await resp.json();
    }

    static getNotificationsMessages = async (accessToken: string, allMessages = false): Promise<INotificationMessage[]> => {
        const headers = { 'Authorization': `Bearer ${accessToken}`};
        const resp = await fetch(process.env.REACT_APP_API_URL + `/api/v3.0/notifications?` + new URLSearchParams({allMessages: encodeURIComponent(allMessages)}), {
            headers,
            mode: 'cors'
        });
        return await resp.json();
    }

    static setAllNotificationsAsRead = async (accessToken: string) => {
        const headers = { 'Authorization': `Bearer ${accessToken}`};
        const resp = await fetch(process.env.REACT_APP_API_URL + `/api/v3.0/notifications/read`, {
            headers,
            method: 'PUT',
            mode: 'cors'
        });

        return await resp;
    }
}
